// @flow
import * as React from 'react';
import styled from 'styled-components';
import ErrorAlert from '../Common/ErrorAlert';
import Typography from '../Common/Typography';
import TextBox from '../Common/TextBox';
import { Button } from '../Common/Button';
import LoginImage from '../../images/LoginImage.jpg';

const Page = styled.div`
  background: url(${LoginImage}) no-repeat center center fixed;
  background-size: cover;
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const Heading = styled.div`
  display: flex;
  flex-basis: 30%;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 0 2rem;
  text-align: center;
`;

const Form = styled.form`
  display: flex;
  flex-basis: 70%;
  flex-direction: column;
`;

const Body = styled.div`
  display: flex;
  flex-basis: 60%;
  flex-direction: column;
  justify-content: center;
  padding: 0 2rem;
`;

const InputGroup = styled.div`
  margin-bottom: 0.75rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.25rem;
`;

const Footer = styled.div`
  display: flex;
  flex-basis: 40%;
  flex-direction: column;
  justify-content: flex-end;
  padding: 2rem;

  button:first-child {
    margin-bottom: 0.5rem;
  }
`;

type Props = {
  companyName: string,
  userName: string,
  password: string,
  errors: Array<string>,
  onChange: (SyntheticKeyboardEvent<HTMLInputElement>) => mixed,
  onClickForgottenPassword: () => void,
  onSubmit: (SyntheticEvent<HTMLButtonElement>) => mixed
};

const LoginMobile = React.memo<Props>((props: Props) => (
  <Page>
    <Heading>
      <Typography kind="h1">{props.companyName}</Typography>
      <Typography kind="h3">Self Service</Typography>
    </Heading>
    <Form onSubmit={props.onSubmit}>
      <Body>
        <div>
          <InputGroup>
            <Label htmlFor="userName">User Name</Label>
            <TextBox
              autoFocus
              autoCapitalize="false"
              type="text"
              id="userName"
              name="userName"
              placeholder="Enter user name"
              fullWidth
              value={props.userName}
              onChange={props.onChange}
            />
          </InputGroup>
          <InputGroup>
            <Label htmlFor="password">Password</Label>
            <TextBox
              autoCapitalize="false"
              type="password"
              id="password"
              name="password"
              placeholder="Enter password"
              fullWidth
              value={props.password}
              onChange={props.onChange}
            />
          </InputGroup>
          <ErrorAlert errors={props.errors} />
        </div>
      </Body>
      <Footer>
        <Button kind="primary" type="submit" fullWidth>
          Login
        </Button>
        <Button
          kind="secondary"
          type="button"
          fullWidth
          onClick={props.onClickForgottenPassword}
        >
          Forgotten Password
        </Button>
      </Footer>
    </Form>
  </Page>
));

export default LoginMobile;
